import { useQueries } from '@tanstack/react-query';

import { queries } from '../../common/api/queryKeys/queries';
import { OrderTabEnum, orderTabOfferStateFilter, orderTabStateFilter } from './orderTabsHelper';

export const useOrderPaginationTotals = ({ searchQuery, customerIds, supplierIds }) => {
    const orderTabs = Object.values(OrderTabEnum);

    // Create queries for each tab with quickFilter: 'ALL' (which means no additional filters)
    const tabQueries = useQueries({
        queries: orderTabs.map((tab) => ({
            ...queries.orders.totals({
                searchQuery,
                customerIds,
                supplierIds,
                tab,
                offerStates: orderTabOfferStateFilter[tab],
                states: orderTabStateFilter[tab],
            }),
            select: (result) => result.count,
        })),
    });

    const data = {};
    orderTabs.forEach((tab, index) => {
        const query = tabQueries[index];
        data[tab] = query.data || 0;
    });

    return data;
};
